module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    ref: "pageBox",
    staticClass: "cc-page"
  }, [_c('campaign-topbar', {
    attrs: {
      "title": "AI Nudge Creation",
      "subtitle": "Create a WhatsApp template with AI: for one or more countries, in every language, with media and variables",
      "show-help": ""
    },
    on: {
      "new-chat": function($event) {
        _vm.showNewChatDialog = true
      },
      "export": _vm.exportChat,
      "help": function($event) {
        _vm.showHelp = true
      }
    }
  }), _vm._v(" "), _c('campaign-steps-bar', {
    attrs: {
      "current-step": _vm.currentStep,
      "steps": _vm.steps
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cc-body"
  }, [_c('template-chat-panel', {
    key: _vm.chatInstanceKey,
    ref: "chatPanel",
    staticClass: "cc-chat",
    attrs: {
      "resume-chat-id": _vm.resumeChatId
    },
    on: {
      "summary-change": _vm.onSummaryChange
    }
  }), _vm._v(" "), _c('template-summary-sidebar', {
    staticClass: "cc-sidebar",
    attrs: {
      "current-step": _vm.currentStep,
      "summary": _vm.summary
    }
  })], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "cc-overlay-fade"
    }
  }, [(_vm.showNewChatDialog) ? _c('div', {
    staticClass: "cc-dialog-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showNewChatDialog = false
      }
    }
  }, [_c('div', {
    staticClass: "cc-dialog"
  }, [_c('h4', {
    staticClass: "cc-dialog-title"
  }, [_vm._v("Start a new chat?")]), _vm._v(" "), _c('p', {
    staticClass: "cc-dialog-body"
  }, [_vm._v("This draft will be closed and a fresh chat will begin. Anything already sent to WhatsApp stays sent.")]), _vm._v(" "), _c('div', {
    staticClass: "cc-dialog-actions"
  }, [_c('button', {
    staticClass: "cc-dialog-btn cc-dialog-btn-cancel",
    on: {
      "click": function($event) {
        _vm.showNewChatDialog = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('button', {
    staticClass: "cc-dialog-btn cc-dialog-btn-confirm",
    on: {
      "click": _vm.confirmNewChat
    }
  }, [_vm._v("Yes")])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "cc-overlay-fade"
    }
  }, [(_vm.showHelp) ? _c('div', {
    staticClass: "cc-dialog-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showHelp = false
      }
    }
  }, [_c('div', {
    staticClass: "cc-dialog ct-help"
  }, [_c('h4', {
    staticClass: "cc-dialog-title"
  }, [_vm._v("How AI Nudge Creation works")]), _vm._v(" "), _c('ol', {
    staticClass: "ct-help-list"
  }, [_c('li', [_c('strong', [_vm._v("Purpose:")]), _vm._v(" text, a link button, a call button, media, or a generic country template. Or copy an existing template to another WhatsApp account.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Where it lives:")]), _vm._v(" customers and countries. Each country's WhatsApp account is worked out for you; several countries can mean several accounts. A journey is optional and only tags the template.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Content:")]), _vm._v(" the AI drafts each language from your goal (up to 5 regenerations). Edit freely; variables like "), _c('code', {
    pre: true
  }, [_vm._v("{{1}}")]), _vm._v(" need a sample for WhatsApp's review. Add an image, video or PDF from Media Management, or upload one.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Name & checks:")]), _vm._v(" the name follows country_therapy-area_purpose_language_ID. WhatsApp's structural rules are checked on every language and account; the category and policy risk are advice.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Submit:")]), _vm._v(" each account × language is its own WhatsApp template. One failing doesn't stop the others, and you can retry just those. It's added to Nudge Template Manager automatically, and you'll get a notification for every decision.")])]), _vm._v(" "), _c('p', {
    staticClass: "cc-dialog-body"
  }, [_vm._v("Type \"change the countries\", \"change the message\" and so on to go back to a step.")]), _vm._v(" "), _c('div', {
    staticClass: "cc-dialog-actions"
  }, [_c('button', {
    staticClass: "cc-dialog-btn cc-dialog-btn-confirm",
    on: {
      "click": function($event) {
        _vm.showHelp = false
      }
    }
  }, [_vm._v("Got it")])])])]) : _vm._e()])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Nudge Template Manager")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("AI Nudge Creation")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6bde6a58","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nudge-console/CreateTemplate.vue
// module id = 1mFJ
// module chunks = 1